import {Button, TextField} from "@mui/material";
import Box from "@mui/material/Box";
import {Edit} from "@mui/icons-material";
import useAlert from "../../../../../../use/useAlert";
import {useRef} from "react";
import isNull from "../../../../../../mixin/isNull";

const ERROR_NAME_REQUIRED = "Nom requis";
const ERROR_PRICE_REQUIRED = "Prix requis";
const ERROR_QUANTITY_REQUIRED = "Quantité requise";

const SHIFTING_NAME = "Déplacement supplémentaire";
const MAIN_WORK_NAME = "Main d'oeuvre supplémentaire";
const FIXED_AS_ARRAY = [
    SHIFTING_NAME,
    MAIN_WORK_NAME
]

export default function ({quotationItem, onSubmit}) {
    const alert = useAlert();
    const nameInput = useRef();
    const descriptionInput = useRef();
    const priceInput = useRef();
    const quantityInput = useRef();

    const submit = () => {
        if (nameInput.current.value.length === 0) {
            alert.warning(ERROR_NAME_REQUIRED);
            return;
        }

        if (priceInput.current.value.length === 0) {
            alert.warning(ERROR_PRICE_REQUIRED);
            return;
        }

        if (quantityInput.current.value.length === 0) {
            alert.warning(ERROR_QUANTITY_REQUIRED);
            return;
        }

        onSubmit({
            name: nameInput.current.value,
            description: descriptionInput.current.value,
            price: priceInput.current.value,
            quantity: quantityInput.current.value,
            standardized_item_id: quotationItem.standardized_item_id,
            default_item_id: quotationItem.default_item_id
        })
    }

    return (
        <>
            <div>
                <TextField
                    inputRef={nameInput}
                    fullWidth
                    autoFocus={isNull(quotationItem.standardized_item_id) && !FIXED_AS_ARRAY.includes(quotationItem.name)}
                    variant={"standard"}
                    label={"Nom de l'item"}
                    defaultValue={quotationItem.name}
                    disabled={!isNull(quotationItem.standardized_item_id) || FIXED_AS_ARRAY.includes(quotationItem.name)}
                    required
                    data-test="input-name"
                />
            </div>
            <Box mt={2}>
                <TextField
                    inputRef={descriptionInput}
                    fullWidth
                    multiline
                    rows={4}
                    variant={"standard"}
                    label={"Description"}
                    defaultValue={quotationItem.description}
                    disabled={!isNull(quotationItem.standardized_item_id)}
                    data-test="input-description"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={priceInput}
                    fullWidth
                    variant={"standard"}
                    label={"Prix HT"}
                    type={"number"}
                    required
                    defaultValue={quotationItem.price}
                    disabled={!isNull(quotationItem.standardized_item_id) || FIXED_AS_ARRAY.includes(quotationItem.name)}
                    data-test="input-price"
                />
            </Box>
            <Box mt={2}>
                <TextField
                    inputRef={quantityInput}
                    fullWidth
                    autoFocus={!isNull(quotationItem.standardized_item_id) || FIXED_AS_ARRAY.includes(quotationItem.name)}
                    variant={"standard"}
                    label={"Quantité"}
                    type={"number"}
                    defaultValue={quotationItem.quantity}
                    required
                    data-test="input-quantity"
                />
            </Box>
            <Box mt={2} display="flex" justifyContent="center">
                <Button
                    startIcon={<Edit/>}
                    variant={"contained"}
                    fullWidth
                    onClick={submit}
                    data-test="button-update-quotation-item"
                >
                    Modifier
                </Button>
            </Box>
        </>
    )
}